import DOMPurify from 'dompurify';
import { convert } from 'html-to-text';

const ALLOWED_TAGS = ['b', 'strong', 'i', 'em', 'u', 'a', 'br', 'p', 'div', 'ul', 'ol', 'li', 'span'];
const ALLOWED_ATTR = ['href', 'target', 'rel'];

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A') {
    node.setAttribute('rel', 'noopener noreferrer');
    node.setAttribute('target', '_blank');
  }
});

export function sanitizeHtml(dirty: string): string {
  if (!dirty) {
    return '';
  }

  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS,
    ALLOWED_ATTR
  });
}

const HTML_CONTENT_PATTERN = /<[a-z][\s\S]*>|&(?:[a-z][a-z0-9]*|#x?[0-9a-f]+);/i;

export function containsHtml(value: string): boolean {
  return HTML_CONTENT_PATTERN.test(value);
}

export function getEditorPlainText(html: string): string {
  if (!html) {
    return '';
  }

  return convert(sanitizeHtml(html), { wordwrap: false }).trim();
}

export function isEmptyEditorHtml(html: string): boolean {
  return getEditorPlainText(html).length === 0;
}
